import * as ToggleGroup from '@radix-ui/react-toggle-group';
import { forwardRef } from 'react';

import { cn } from '~/chords/lib/cn';

export type SegmentedControlProps =
  | Omit<ToggleGroup.ToggleGroupSingleProps, 'className'>
  | Omit<ToggleGroup.ToggleGroupMultipleProps, 'className'>;

const SegmentedControlBase = forwardRef<HTMLDivElement, SegmentedControlProps>(
  (props, ref) => {
    return (
      <ToggleGroup.Root
        ref={ref}
        {...props}
        className={cn(
          'flex w-min items-center gap-xs rounded-sm p-xs bg-level-01',
        )}
      />
    );
  },
);

const SegmentedControlItem = forwardRef<
  HTMLButtonElement,
  Omit<ToggleGroup.ToggleGroupItemProps, 'className'>
>((props, ref) => {
  return (
    <ToggleGroup.Item
      ref={ref}
      {...props}
      className={cn(
        'flex min-h-2xl items-center gap-sm truncate rounded-sm border-t-px px-md py-sm transition-colors-with-outline border-transparent text-default',
        'enabled:hover:bg-emphasis-strong',
        'enabled:active:bg-emphasis-default',
        'data-[state=on]:bg-emphasis-subtle',
        'data-[state=on]:border-t-emphasis-default',
        'enabled:data-[state=on]:bg-[linear-gradient(225deg,oklch(var(--color-neutral-450))_0%,oklch(var(--color-neutral-550))_100%)]',
        'enabled:data-[state=on]:text-tertiary-default',
        'enabled:hover:data-[state=on]:bg-none enabled:hover:data-[state=on]:bg-emphasis-strong',
        'enabled:active:data-[state=on]:bg-emphasis-default',
        'disabled:text-disabled',
        'disabled:data-[state=on]:text-subtle',
      )}
    />
  );
});

SegmentedControlBase.displayName = 'SegmentedControl';
SegmentedControlItem.displayName = 'SegmentedControl.Item';

export const SegmentedControl =
  SegmentedControlBase as typeof SegmentedControlBase & {
    Item: typeof SegmentedControlItem;
  };

SegmentedControl.Item = SegmentedControlItem;
